module.exports = __webpack_public_path__ + "static/media/quote.c770f36e.svg";